import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { Observable, timer, Subscription } from 'rxjs';
import { take, map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { IOtpConfig } from '../../models/otp-config.model';
import { Store } from '@ngrx/store';
import * as loginConfirm from '../../actions/login-confirm.actions';
import * as loginConfirmSelector from '../../selectors/login-confirm.selectors';
import { IOtpRequest, IOtpResponse } from '../../../../core/models/otp.model';
import { ICheckRegisterRequiredRequest } from '../../../../core/models/check-registration.model';
import * as logout from '../../actions/logout.actions';
import { fromForgotPasscodeSelector } from '../../selectors/index';
import { IGenericError, ErrorResponse } from '../../../../core/models/generic-models';
import * as otpFailure from '../../selectors/login-confirm.selectors';
import { IResendOtpRequest, IResendOtpResponse } from '../../../../core/models/otp-resend.model';
import * as resendOtp from '../../actions/resend-otp.actions';
import * as resendingOtpSelector from '../../selectors/resend-otp.selectors';
import * as loginSelector from '../../selectors/login.selectors';
import { fromLoginSelector } from '../../selectors';
import { IRegistrationLoginSuccess } from '../../models/registration-login.model';
import { APP_CONFIG } from '../../../../config/app-config.module';
import { AppConfig } from '../../../../core/config-models/app-config.model';
import { SharedService } from '../../../../shared/shared.service';

@Component({
  selector: 'app-otp',
  templateUrl: './otp.component.html',
  styleUrls: ['./otp.component.css']
})
export class OtpComponent implements OnInit {
  otpConfig: Partial<IOtpConfig>;
  countDownTimer$: Observable<number>;
  tick: number;
  otpTimer: number;
  getUserMobileData$: Observable<ICheckRegisterRequiredRequest>;
  getUserMobileDataSubscription: Subscription = new Subscription();
  userDialingCode: string;
  userMobileNumber: string;
  isOtpLoading$: Observable<boolean>;
  otpFailure$: Observable<IGenericError<ErrorResponse>>;
  isResendingOtpLoading$: Observable<boolean>;
  isResendingOtpFailure$: Observable<IGenericError<ErrorResponse>>;
  resendSuccess$: Observable<IResendOtpResponse>;
  loginResponse$: Observable<IRegistrationLoginSuccess>;
  loginConfirmResponse$: Observable<IOtpResponse>;
  passcode: string;
  enterOtp: boolean;
  @ViewChild('ngOtpInput') ngOtpInputRef: any;
  resendOtpToMobileMethod: string = 'C4C0C190-7D76-45A7-88A4-BE7ADD2869DC';
  resendOtpToEmailMethod: string = 'D3BEC764-EC4B-43D9-961B-DF990D6B024E';
  resendOtpToWhatsAppMethod: string = '242D8F87-341F-4576-950F-923B596D7DB8';
  subdomain: string;

  constructor(
    private router: Router,
    private store: Store,
    private sharedService: SharedService,
    @Inject(APP_CONFIG) private appConfig: AppConfig
  ) {
    this.subdomain = this.sharedService.getSubDomain();
    this.enterOtp = true;
    this.tick = 1000;
    this.otpTimer = 30;
    this.otpConfig = {
      length: 6,
      allowNumbersOnly: true,
      inputStyles: {
        'border-left': 'none',
        'border-top': 'none',
        'border-right': 'none',
        'border-bottom': '1px solid',
        outline: 'none',
        'border-bottom-left-radius': '0px',
        'border-bottom-right-radius': '0px'
      }
    };

    this.getUserMobileData$ = this.store.select(fromLoginSelector.getLoginRequest);
    this.loginResponse$ = this.store.select(loginSelector.getLoginSuccess);
  }

  ngOnInit(): void {
    this.startCountTimer();
    this.getUserMobileDataSubscription = this.getUserMobileData$.subscribe(userDetails => {
      if (userDetails !== undefined) {
        this.userDialingCode = userDetails.dialingCode;
        this.userMobileNumber = userDetails.mobileNumber;
      } else {
      }
    });

    this.store.select(loginSelector.getLoginRequest).subscribe(details => {
      this.passcode = details?.passcode;
    });

    this.loginConfirmResponse$ = this.store.select(loginConfirmSelector.getLoginConfirmSuccess);
    this.isOtpLoading$ = this.store.select(otpFailure.getLoginConfirmIsLoading);
    this.otpFailure$ = this.store.select(otpFailure.getLoginConfirmFailure);
  }

  navBackBtn() {
    this.router.navigateByUrl('/auth/sign-up');
  }

  onOtpChange(otpDigits: string) {
    if (otpDigits.length === 6 && this.enterOtp) {
      this.enterOtp = false;
      const req: IOtpRequest = {
        dialingCode: this.userDialingCode,
        mobileNumber: this.userMobileNumber,
        otp: otpDigits
      };

      this.store.dispatch(loginConfirm.loadLoginConfirmRequest({ request: req }));
    } else if (otpDigits.length < 6) {
      this.enterOtp = true;
    }
  }

  resendOtp(val) {
    this.ngOtpInputRef.setValue('');
    this.otpTimer = 30;
    this.enterOtp = true;
    this.startCountTimer();
    const req: IResendOtpRequest = {
      resendOTPMethod: val == 1 ? this.resendOtpToWhatsAppMethod : val == 2 ? this.resendOtpToMobileMethod : this.resendOtpToEmailMethod,
      dialingCode: this.userDialingCode,
      mobileNumber: this.userMobileNumber,
      passcode: this.passcode,
      uniqueDeviceId: '00000000-0000-0000-0000-000000000000',
      firebaseTokenId: '00000000-0000-0000-0000-000000000000',
      make: '',
      model: '',
      totalDiskCapacity: ''//,
    };

    this.store.dispatch(resendOtp.loadResendOtpRequest({ request: req }));

    this.isResendingOtpLoading$ = this.store.select(resendingOtpSelector.getResendOtpIsLoading);

    this.resendSuccess$ = this.store.select(resendingOtpSelector.getResendOtpSuccess);

    this.isResendingOtpFailure$ = this.store.select(resendingOtpSelector.getResendOtpFailure);
  }

  startCountTimer() {
    this.countDownTimer$ = timer(0, this.tick).pipe(
      take(this.otpTimer),
      map(() => --this.otpTimer)
    );
  }
}
